import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Loader from '../../components/Loader';
import { ModalBase } from '../../components/ModalBase';
import { useAuth } from '../../context/AuthContext';
import { RemoveUsuarioDto } from '../../interfaces/user';
import { routes } from '../../routes/routeConfig';
import UsersService from '../../services/UsersService';

const DeleteAccount = () => {
    const [openModal, setOpenModal] = useState(false);
    const [initAction, setInitAction] = useState(true);
    const [deleteSuccess, setDeleteSuccess] = useState(false);
    const [loadingExit, setLoadingExit] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const navigate = useNavigate();
    const { user, logout } = useAuth();
    const logoutTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    const handleCancel = async () => {
        setOpenModal(false);
        setInitAction(true);
        setDeleteSuccess(false);
    };

    const deleteAccount = async () => {
        try {
            setDeleting(true);
            const req: RemoveUsuarioDto = {
                id_usuario: user!.id_usuario,
                email: user!.email,
            };
            const res = await UsersService.removeUser(req);
            console.log('log', res);
            if (res && res.statusCode === 200) {
                setInitAction(false);
                setDeleteSuccess(true);
            } else {
                setInitAction(false);
                setDeleteSuccess(false);
            }

        } catch (error) {
            setInitAction(false);
            setDeleteSuccess(false);
        } finally {
            setDeleting(false);
        }

    };

    const postDeleted = async () => {
        setLoadingExit(true);
        logoutTimerRef.current = setTimeout(() => {
            logout();
            navigate(routes.redirects.afterLogout);
        }, 600);
    };

    useEffect(() => {
        return () => {
            if (logoutTimerRef.current) {
                clearTimeout(logoutTimerRef.current);
            }
        };
    }, []);

    if (loadingExit) {
        return <div className='logout-overlay'>
            <Loader text='Cerrando sesión...' />
        </div>;
    }


    return (
        <div>
            <h2>Eliminar mi cuenta</h2>
            <p>Esta acción es irreversible e implica que perderás todos los datos ingresados</p>
            <button
                className='btn btn-error'
                style={{ width: '100%', maxWidth: 200 }}
                onClick={() => setOpenModal(true)}
            >
                Eliminar cuenta
            </button>

            <ModalBase
                isOpen={openModal}
                shouldCloseOnOverlayClick={false}
                closeButton={initAction && !deleteSuccess}
                onRequestClose={handleCancel}
                title={initAction ? '¿Estás segura de eliminar tu cuenta?' : deleteSuccess ? 'Cuenta eliminada...' : 'Error al eliminar la cuenta'}
                type={initAction ? 'warning' : 'error'}
                footerButtons={[
                    (initAction || !deleteSuccess) && (
                        <button
                            className='btn btn-secondary'
                            key='cancel'
                            onClick={handleCancel}
                        >
                            Cancelar
                        </button>
                    ),
                    initAction && (
                        <button
                            key='confirm-delete'
                            className='btn btn-primary'
                            onClick={deleteAccount}
                            disabled={deleting}
                        >
                            {deleting ? 'Eliminando...' : 'Sí, eliminar'}
                        </button>
                    ),
                    deleteSuccess && (
                        <button
                            key='eliminar'
                            className='btn btn-primary'
                            onClick={postDeleted}
                        >
                            Salir
                        </button>
                    ),
                ].filter(Boolean)}
            >
                <div>
                    {initAction ? 'Piénsalo otra vez...' : deleteSuccess ? 'Tu cuenta ha sido eliminada exitosamente. Lamentamos verte partir.' : 'Hubo un error al intentar eliminar tu cuenta. Por favor, intenta nuevamente más tarde.'}
                </div>
            </ModalBase>
        </div>
    );
};

export default DeleteAccount;